import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Box, CircularProgress } from '@mui/material'

import { BasicTable } from '../../../../ui'
import { IP_EVENTS_TABLE_CONFIG } from './events-table.constants'
import { useIPContext } from '../../contexts'

export const IPEventsTable = () => {
  const intl = useIntl()
  const { getIPEvents, events, ip } = useIPContext()

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (ip.id) {
      setLoading(true)
      getIPEvents(ip.id)
        .then(() => {
          setLoading(false)
        })
        .catch(() => {
          setLoading(false)
        })
    }
  }, [ip]) // eslint-disable-line react-hooks/exhaustive-deps

  if (loading)
    return (
      <Box display="flex" width="100%" justifyContent="center" alignItems="center">
        <CircularProgress size={40} />
      </Box>
    )
  return events.length ? (
    <BasicTable config={IP_EVENTS_TABLE_CONFIG(intl)} data={events} loading={loading} />
  ) : (
    intl.formatMessage({ id: 'pages.ip.detail.events.emptyList' })
  )
}
